//#region ../../node_modules/lodash-es/_cacheHas.js
/**
* Checks if a `cache` value for `key` exists.
*
* @private
* @param {Object} cache The cache to query.
* @param {string} key The key of the entry to check.
* @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
*/
function cacheHas(cache, key) {
	return cache.has(key);
}
var _cacheHas_default = cacheHas;

//#endregion
export { _cacheHas_default as default };
//# sourceMappingURL=_cacheHas.js.map